import '@/css/app.css'
import Alpine from 'alpinejs'
import Headroom from 'headroom.js'
import collapse from '@alpinejs/collapse'
import './cookie-consent-mode.js'
import './base/revealOnScroll.js'
import './base/parallax.js'
import './base/blockTabsPin.js'
import './base/blockHorCardsStack.js'
import './base/sprigOverview.js'
import { initShareButton } from './base/share.js'
import { initTabs } from './base/tabs.js'

import { initBorderAnimated } from '@/js/base/borderAnimated'
import { initMapPings } from '@/js/base/mapPings'
import { initHoverCursor, initMagneticCursor } from '@/js/base/hoverCursor'
import { initFileUpload } from '@/js/base/fileUpload'
import { initMegaMenu } from '@/js/base/megaMenu'
import { initSplitTextReveal } from '@/js/base/splitTextReveal'
import { initTopTitle } from '@/js/base/topTitle'

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

import Lenis from 'lenis'
const lenis = new Lenis({
    autoRaf: true,
    anchors: {
        offset: -50
    },
    prevent: (node) => {
        const classes = ['pm-wrapper']
        return classes.some((cls) => node.classList.contains(cls))
    }
})

window.lenis = lenis

const headroom = () => {
    const headroom = new Headroom(document.querySelector('header'), {
        offset: 100,
        onTop: function () {
            document.querySelector('body').classList.add('headroom--top')
            document.querySelector('body').classList.remove('headroom--not-top')
        },

        onNotTop: function () {
            document.querySelector('body').classList.remove('headroom--top')
            document.querySelector('body').classList.add('headroom--not-top')
        }
    }).init()
}

// Blur pas na een korte pauze aanzetten, niet meteen bij load: de pagina
// (video, fonts, ScrollTrigger, ...) is dan al gesetteld, wat de Chromium
// ghost/flicker-glitch op de allereerste paint moet vermijden. Zelfde
// off->on + forced reflow als megaMenu.js, zodat de fade-in ook echt
// animeert i.p.v. meteen te "snappen".
const initHeaderBlur = () => {
    const header = document.querySelector('header')

    if (!header) return

    setTimeout(() => {
        header.dataset.blur = 'off'
        void header.offsetWidth
        header.dataset.blur = 'on'
    }, 1000)
}

// App main
const main = async () => {
    headroom()
    initHeaderBlur()
    // Dit komt overeen met de twig var blockHandle
    // const blocks = []
    const components = [
        'fancybox',
        'swiper',
        'accordionComp',
        'langSwitcher',
        'googleMaps',
        'faq',
        'count',
        'plyr'
    ]

    const importPromises = []

    // for (const block of blocks) {
    //     const blockElements = document.querySelectorAll(`.${block}`)

    //     if (blockElements.length === 0) {
    //         continue
    //     }

    //     const importPromise = import(`./blocks/${block}.js`).then(
    //         ({ init }) => {
    //             blockElements.forEach((block) => {
    //                 importPromises.push(init(block))
    //             })
    //         }
    //     )

    //     importPromises.push(importPromise)
    // }

    for (const comp of components) {
        const compElements = document.querySelectorAll(`.${comp}`)
        if (compElements.length === 0) {
            continue
        }

        const importPromise = import(`./components/${comp}.js`).then(
            ({ init }) => {
                compElements.forEach((comp) => {
                    importPromises.push(init(comp, lenis))
                })
            }
        )

        importPromises.push(importPromise)
    }

    importPromises.push(
        import('./base/animations.js').then(({ initAnimations }) =>
            initAnimations()
        )
    )

    importPromises.push(
        import('./base/menu.js').then(({ initMenu }) => initMenu())
    )

    importPromises.push(
        import('./base/mobileNav.js').then(({ initMobileNav }) =>
            initMobileNav()
        )
    )
    return await Promise.all(importPromises)
}

main().then(() => {
    console.log('Vite <3')
    window.Alpine = Alpine

    Alpine.plugin(collapse)
    Alpine.start()

    const anchor = getAnchor()
    if (anchor) {
        const anchorElement = document.querySelector(`#${anchor}`)
        if (anchorElement) {
            setTimeout(() => {
                lenis.scrollTo(anchorElement, {
                    offset: -50
                })
            }, 500)
        }
    }
})

const getAnchor = () => {
    var currentUrl = document.URL,
        urlParts = currentUrl.split('#')

    return urlParts.length > 1 ? urlParts[1] : null
}

if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log('HMR')
    })
}

document.addEventListener('DOMContentLoaded', () => {
    initBorderAnimated()
    initMapPings()
    initHoverCursor()
    initMagneticCursor()
    initFileUpload()
    initMegaMenu()
    initShareButton()
    initTabs()
    initSplitTextReveal()
    initTopTitle()

    function autoGrow(textarea) {
        textarea.style.height = 'auto'
        textarea.style.height = textarea.scrollHeight + 'px'
    }

    document.querySelectorAll('textarea').forEach((textarea) => {
        textarea.addEventListener('input', () => autoGrow(textarea))
        autoGrow(textarea)
    })

    setTimeout(() => {
        window.dispatchEvent(new Event('resize'))
        ScrollTrigger.refresh()
    }, 1000)
})
